import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { Menu, Dropdown, Icon, Avatar, Tag } from '@beehive/components';
import { AccountState } from 'modules/types/account';
import * as actions from 'modules/actions/account';
import LanguageModal from './LanguageModal';
import ResetPwdModal from './ResetPwdModal';
import ChangeSupplierModal from './ChangeSupplierModal';

import PropTypes from 'prop-types';
import messages from 'messages';
import { Computer } from '@bedrock/icons-react';
import ScreenZoomSetting from "@mpc/common/src/features/ScreenZoomSetting";

interface SettingProps {
  logout: () => void;
  onMenuVisibleChange: Function;
  needShowChangeSupplier: boolean;
}

const Setting: React.FC<SettingProps> = (props, context) => {
  const { intl } = context;
  const { logout, onMenuVisibleChange, needShowChangeSupplier } = props;
  return (
    <Menu>
      {needShowChangeSupplier ? <Menu.Item key="exchange">
        <ChangeSupplierModal onMenuVisibleChange={onMenuVisibleChange} />
      </Menu.Item> : null}
      <Menu.Item key="resetPassword">
        <ResetPwdModal onMenuVisibleChange={onMenuVisibleChange} />
      </Menu.Item>
      <Menu.Item key="languageSetting">
        <LanguageModal onMenuVisibleChange={onMenuVisibleChange} />
      </Menu.Item>
      <Menu.Item key="setting" onClick={() => onMenuVisibleChange(false)} >
        {/* <Computer /> */}
        <ScreenZoomSetting />
      </Menu.Item>
      <Menu.Item onClick={logout} key="logout">
        {intl.formatMessage(messages.logOut)}
      </Menu.Item>
    </Menu>
  );
};

Setting.contextTypes = {
  intl: PropTypes.object,
};

export interface HeaderProps {
  account: AccountState;
  logout: any;
  permissions: string[];
  suppliersList: Array<Record<string, any>>;
}

class Header extends React.Component<HeaderProps, any> {

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      dropdownVisible: false,
    };
  }

  handleLogout = () => {
    this.props.logout().then(() => {
      window.location.href = '/';
    });
  }

  handleVisibleChange = (visible: boolean) => {
    this.setState({
      dropdownVisible: visible,
    });
  }

  render() {
    const { account, suppliersList } = this.props;
    const { dropdownVisible } = this.state;
    const curSupplier = suppliersList.find((v: any) => v.selected) || {};

    let full_name = curSupplier.full_name;
    if (curSupplier.is_new) {
        full_name = `${curSupplier.full_name} (${curSupplier.channel_type_name})`;
    }

    const setting = (
      <Setting
        logout={this.handleLogout}
        onMenuVisibleChange={this.handleVisibleChange}
        needShowChangeSupplier={suppliersList.length > 1}
      />
    );

    return (
      <div className="pull-right header-setting">
        <Dropdown
          align={{ offset: [-12, 0] }}
          overlay={setting}
          trigger={['click']}
          placement="bottomRight"
          onVisibleChange={this.handleVisibleChange}
          visible={dropdownVisible}
        >
          <div className="">
            <Avatar imgUrl={account.avatar_url} className="mpc-avatar"/>
            <Tag
              isElliptical
              style={{ maxWidth: 250 }}
              text={full_name}
              colorOpposite
              color="#333"
              title={full_name}
            />
            <Icon name={dropdownVisible ? 'angle-up' : 'angle-down'} size={10} />
            {/* {account.name}<Icon name={dropdownVisible ? 'angle-up' : 'angle-down'} size={10} /> */}
          </div>
        </Dropdown>
      </div>
    );
  }
}

const mapState2Props = (state: any) => {
  return {
    account: state.account,
    suppliersList: state.account.suppliersList,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<actions.AccountActions>) => {
  return bindActionCreators({
    logout: actions.userLogout,
  }, dispatch);
};

export default connect(mapState2Props, mapDispatchToProps)(Header);
